var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTuristinformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#ef6545"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.581,12.509H8.8V8.731a.41.41,0,0,0,.01-.048.386.386,0,0,0-.01-.049V8.58H8.784a.369.369,0,0,0-.354-.272H6.3a.375.375,0,0,0,0,.75h.5v3.451H6.01a.375.375,0,1,0,0,.75H9.581a.375.375,0,0,0,0-.75Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79,6.5a1,1,0,1,0-.995,1A.994.994,0,0,0,8.79,6.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.668,5.27,8.052,1.9a.493.493,0,0,0-.513,0L1.922,5.27a.5.5,0,0,0,.257.928.492.492,0,0,0,.257-.071L7.8,2.915l5.36,3.212a.5.5,0,0,0,.513-.857Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuristinformation);
export default __webpack_public_path__ + "static/media/TURISTINFORMATION.608b6adced6edaebb7efce0dc0cd017e.svg";
export { ForwardRef as ReactComponent };